import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
import { Form, FormSpy, Field } from "react-final-form";
import MainLayout from "layout/MainLayout";
import FinalFormInput from "components/FinalFormInput";
import Dropzone from "components/Dropzone";
import Ad from "components/Ad";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "utils/axios";

const CreateAd = () => {
  const [file, setFile] = useState<any>({});
  const [adInfo, setAdInfo] = useState<any>({});
  const [resourceNameList, setResourceNameList] = useState<Array<any>>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadResourceName = async () => {
      const { organization, userType } = cookie.load("user");
      const { data } =
        userType === "admin" || userType === "super_user"
          ? await axios.get(`/api/resource/getByOrganization/${organization}`)
          : await axios.get("/api/resource/getAllResourceName");
      let array: any = [];
      data.map((item: any) => array.push(item.name));
      setResourceNameList(array);
    };
    loadResourceName();
  }, []);

  const createAd = async (val: any) => {
    if (file.file === "") {
      toast.warning("Please upload logo image!");
      return;
    }
    if (!resourceNameList.includes(val.resourceName)) {
      toast.warning("Please choose correct Resource Name!");
      return;
    }
    Swal.fire({
      title: "<h6>Are you sure you want to create this ad?</h6>",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Confirm`,
      denyButtonText: `Cancel`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        try {
          const { tokenId, title: username } = cookie.load("user");
          const result = await axios.get(
            `/api/resource/getOrganizationFromResource/${val.resourceName}`
          );
          const organization = result.data.organization;
          const response = await axios.post("/api/ad/create", {
            tokenId: Number(tokenId),
            username,
            ...val,
            organization,
            image: file.file,
          });
          toast.success(response.data.message);
          navigate("/dashboard");
        } catch (error: any) {
          toast.error(error.response.data.message);
        }
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const handleChange = ({ values: val }: any) => {
    let tempInfo = adInfo;
    tempInfo.title = val.title;
    tempInfo.resourceName = val.resourceName;
    tempInfo.websiteLink = val.websiteLink;
    tempInfo.description = val.description;
    setAdInfo(tempInfo);
  };

  const handleClick = (errors: any, values: any) => {};

  return (
    <MainLayout title="Create Ad">
      <Form
        onSubmit={(val) => createAd(val)}
        render={({ handleSubmit, errors, values }) => (
          <form
            className="containers my-20 sm:my-[36px] xl:w-[613px] lg:w-[613px] md:max-w-[613px] flex flex-col"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <FormSpy subscription={{ values: true }} onChange={handleChange} />
            <h4>Create an Ad</h4>
            <div className="content grid gap-[12px] my-8">
              <Field id="title" name="title" placeholder="Title">
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field
                id="resourceName"
                name="resourceName"
                placeholder="Resource Name"
              >
                {(props: any) => (
                  <FinalFormInput
                    {...props}
                    component="autocomplete"
                    options={resourceNameList}
                    required
                  />
                )}
              </Field>
              <Field
                id="websiteLink"
                name="websiteLink"
                placeholder="Website Link"
              >
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field
                id="description"
                name="description"
                placeholder="Description"
              >
                {(props: any) => (
                  <FinalFormInput
                    {...props}
                    component="textarea"
                    rows={5}
                    required
                  />
                )}
              </Field>
              <Dropzone
                acceptType={{ "image/*": [] }}
                setFile={(f: any, type: any) => {
                  setFile({ file: f, type: type });
                }}
              />
            </div>
            <h5 className="text-[#A9A9A9] mb-[12px]">PREVIEW</h5>
            <Ad
              title={adInfo.title}
              resourceName={adInfo.resourceName}
              websiteLink={adInfo.websiteLink}
              description={adInfo.description}
              file={file.file}
            />
            <button
              type="submit"
              className="high-emphasis ml-auto mt-6"
              onClick={() => handleClick(errors, values)}
            >
              SUBMIT
            </button>
          </form>
        )}
      />
    </MainLayout>
  );
};

export default CreateAd;
